/**
 * Промежуток-101%: UnvDialog/UnvModal → adapter поверх единого UnvUI/Modal.
 *
 * Старый API (open / title / onClose / footer / width / closeOnBackdrop /
 * hasUnsavedChanges / onBack) сохранён. Под капотом теперь единственная
 * реализация UnvUI/Modal — общий portal, scroll-lock, focus-trap, z-index.
 */
import React from 'react'
import { useTranslation } from 'react-i18next'
import UnvModalCore from 'components/UnvUI/Modal'

const widthToSize = (w) => {
  if (!w) return 'md'
  if (typeof w === 'string') {
    const px = parseInt(w, 10)
    if (Number.isFinite(px)) {
      if (px <= 360) return 'xs'
      if (px <= 480) return 'sm'
      if (px <= 720) return 'md'
      if (px <= 960) return 'lg'
      return 'xl'
    }
  }
  if (typeof w === 'number') {
    if (w <= 360) return 'xs'
    if (w <= 480) return 'sm'
    if (w <= 720) return 'md'
    if (w <= 960) return 'lg'
    return 'xl'
  }
  return 'md'
}

function UnvModal({
  open,
  title,
  onClose,
  children,
  footer,
  width,
  closeOnBackdrop = true,
  hasUnsavedChanges = false,
  onBack,
}) {
  const { t } = useTranslation('common')

  const safeClose = () => {
    if (hasUnsavedChanges) {
      const ok = window.confirm(
        t('common.unsaved_confirm', 'Закрыть без сохранения? Введённые данные будут потеряны.'),
      )
      if (!ok) return
    }
    if (onClose) onClose()
  }

  const titleString = typeof title === 'string' ? title : undefined
  const titleNode = title && typeof title !== 'string' ? title : null

  return (
    <UnvModalCore
      open={!!open}
      onClose={safeClose}
      title={titleString}
      size={widthToSize(width)}
      closeOnOverlay={closeOnBackdrop}
    >
      {(onBack || titleNode) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label={t('common.back', 'Назад')}
              style={{
                appearance: 'none',
                border: 0,
                background: 'transparent',
                cursor: 'pointer',
                fontSize: 18,
                color: 'var(--color-text-soft)',
                padding: '4px 8px',
                borderRadius: 6,
              }}
            >
              ←
            </button>
          ) : null}
          {titleNode}
        </div>
      )}
      {children}
      {footer ? (
        <div
          style={{
            marginTop: 16,
            paddingTop: 12,
            borderTop: '1px solid var(--color-border)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          {footer}
        </div>
      ) : null}
    </UnvModalCore>
  )
}

export default UnvModal
